// import {MyButton} from "../../ui/MyButton";
import {MyInputSearch} from "../../ui/MyInputSearch";
import {Content, BtnClose, buttonStyle, AboutMoleculeWrapper} from "./styles";
import IconMolecula from "../../assets/icons/molecule_icon.svg";
import IconXClose from "../../assets/icons/xClose.svg";
import IconQuestion from "../../assets/icons/info-italic.svg";
import {useEffect, useRef, useState} from "react";
import {Button} from "@mui/material";
import {
  IMoleculesDataFromServer,
  ITechMolecules2FromServerWithProducts,
} from "../../pages/Dashboard/Dashboard.type";
import {ITypeRadar} from "../../types";

interface Iprops {
  onOpenMolecule: () => void;
  setIdMoleculeActiv: (arg0: number | string) => void;
  setMoleculeVActive: (arg0: number) => void;
  moleculesData?: IMoleculesDataFromServer[];
  moleculesData2?: ITechMolecules2FromServerWithProducts[];
  setTypeRadar: (arg0: ITypeRadar) => void;
}

const SearchMoleculesTopBar: React.FC<Iprops> = ({
  onOpenMolecule,
  setIdMoleculeActiv,
  setMoleculeVActive,
  moleculesData,
  moleculesData2,
  setTypeRadar,
}) => {
  const [isShowAboutMolecule, setIsShowAboutMolecule] = useState(false);
  const [showListMolecule, setShowListMolecule] = useState<1 | 2>(1);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current.contains(event.target as Node)
      ) {
        setIsShowAboutMolecule(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Content>
      <MyInputSearch
        placeholder="Введите название продукта"
        onOpenMolecule={onOpenMolecule}
        setIdMoleculeActiv={setIdMoleculeActiv}
        setMoleculeVActive={setMoleculeVActive}
        showListMolecule={showListMolecule}
        moleculesData={moleculesData}
        moleculesData2={moleculesData2}
        setTypeRadar={setTypeRadar}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 15px 16px",
        }}
      >
        <div style={{display: "flex", gap: 8}}>
          <Button
            style={buttonStyle(showListMolecule === 1)}
            onClick={() => setShowListMolecule(1)}
            size="small"
          >
            Молекула 1.0
          </Button>
          <Button
            color="inherit"
            style={buttonStyle(showListMolecule === 2)}
            onClick={() => setShowListMolecule(2)}
            size="small"
          >
            Молекула 2.0
          </Button>
        </div>
        <img
          src={IconQuestion}
          width={20}
          height={20}
          alt=""
          style={{cursor: "pointer"}}
          onClick={() => setIsShowAboutMolecule(true)}
        />
      </div>

      {/* <MyButton>Найти молекулу</MyButton> */}
      <AboutMoleculeWrapper isShow={isShowAboutMolecule} ref={contentRef}>
        <div className="aboutMoleculeHeader">
          <div style={{display: "flex", alignItems: "center"}}>
            <img src={IconMolecula} alt="IconMolecula" />
            Что такое молекула 1.0?
          </div>
          <BtnClose style={{}} onClick={() => setIsShowAboutMolecule(false)}>
            <img
              src={IconXClose}
              alt=""
              style={{opacity: 0.7, marginRight: 0}}
            />
          </BtnClose>
        </div>
        <div style={{marginTop: 8}}>
          Молекула 1.0 показывает силу связи между продуктом и технологиями. Чем
          сильнее связь - тем важнее технология для создания продукта.
        </div>
        <hr />
        <div className="aboutMoleculeHeader">
          <div style={{display: "flex", alignItems: "center"}}>
            <img src={IconMolecula} alt="IconMolecula" />
            Что такое молекула 2.0?
          </div>
        </div>
        <div style={{marginTop: 8}}>
          Молекула 2.0 позволяет найти наиболее синергичные продукты компаний,
          которые помогут улучшить или создать целевой продукт.
        </div>
      </AboutMoleculeWrapper>
    </Content>
  );
};

export default SearchMoleculesTopBar;
